export default {
      id: "did-you-know-usage",
      viewBox: "0 0 634 324",
      url: __webpack_public_path__ + "sprite.svg#did-you-know",
      toString: function () {
        return this.url;
      }
    }